import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export interface SidebarProps {
  side?: 'left' | 'right'
  variant?: 'sidebar' | 'floating' | 'inset'
  collapsible?: 'offcanvas' | 'icon' | 'none'
  class?: HTMLAttributes['class']
}

export const sidebarMenuButtonVariants = cva(
  'peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
        outline:
          'bg-background shadow-[0_0_0_1px_var(--sidebar-border)] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_var(--sidebar-accent)]',
        // App-shell navigation look (Gatship sidebars). Carries the
        // pre-shadcn-migration item styling so call sites compose bare
        // primitives without per-item override strings: auto height,
        // rounded-lg, accent/50 states, primary leading icon when
        // active, an exact-active indicator bar (`before:` pseudo keyed
        // on a `data-exact-active` attribute, sitting in the px-5
        // gutter), and icon-rail compaction.
        nav: 'relative h-auto! w-full select-none gap-2 overflow-visible whitespace-nowrap rounded-lg px-3 py-2 text-secondary-foreground transition duration-200 ease-out hover:bg-accent/50 hover:text-secondary-foreground active:bg-accent/50 active:text-secondary-foreground data-[active=true]:bg-accent/50 data-[active=true]:font-normal data-[active=true]:text-secondary-foreground data-[active=true]:[&>svg]:text-primary before:bg-primary before:absolute before:-left-5 before:top-1/2 before:hidden before:h-5 before:w-1 before:-translate-y-1/2 before:rounded-r-full data-[exact-active=true]:before:block group-data-[collapsible=icon]:h-auto! group-data-[collapsible=icon]:w-fit! group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:rounded-sm group-data-[collapsible=icon]:p-2! group-data-[collapsible=icon]:before:-left-[15px] group-data-[collapsible=icon]:[&>svg]:size-4.5'
      },
      size: {
        default: 'h-8 text-sm',
        sm: 'h-7 text-xs',
        lg: 'h-12 text-sm group-data-[collapsible=icon]:p-0!'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

export type SidebarMenuButtonVariants = VariantProps<
  typeof sidebarMenuButtonVariants
>
